/**
 * Presets for the post-login announcement modal (`TimeshareAnnouncementModal`).
 * Attach only to brands that should show the modal (e.g. MRR in `brandConfig`).
 *
 * Videos use **Loom** embeds. Paste the **Share** link from Loom (Share → copy link).
 * Privacy must allow “anyone with the link” to view.
 */

import { PostLoginModalAudience } from '../utils/owner-portal/userConstants';

export interface PostLoginModalConfig {
  /** Firestore: `ownerPortalModals.{announcementKey}.dismissedPermanently` */
  announcementKey: string;
  /**
   * Loom share URL (`https://www.loom.com/share/…`) or embed URL (`…/embed/…`).
   * A bare 32-character video id is also accepted.
   */
  videoUrl: string;
  /**
   * Optional static poster image URL: shown until the user taps, then the Loom embed loads with
   * autoplay. When omitted, the embed is shown immediately and Loom provides the thumbnail and play control.
   */
  posterImageUrl?: string;
  title: string;
  description: string;
  ctaLabel: string;
  /** In-app route (e.g. `/timeshare/new`) */
  ctaPath: string;
  /** `iframe` title; defaults to a generic label if omitted */
  iframeTitle?: string;
  /** Optional Tailwind classes for the primary CTA (pill button). */
  ctaButtonClassName?: string;
  /**
   * When set, only users in this audience see the modal. Omit to allow any eligible property owner
   * after the timeshare query succeeds (legacy behavior).
   */
  audience?: PostLoginModalAudience;
}

/** Maui Resort Rentals — timeshare listing walkthrough announcement */
export const MRR_POST_LOGIN_MODALS: PostLoginModalConfig[] = [
  {
    announcementKey: 'timeshareListingWalkthrough',
    audience: PostLoginModalAudience.Timeshare,
    /** Replace with your Loom Share link when the walkthrough is ready. */
    videoUrl: 'https://www.loom.com/share/7458e68292fc49bca27505d51b805ce9',
    title: "Unlock Your Timeshare’s Potential!",
    description:
      "Introducing dedicated tools for timeshare owners. Watch this 3-minute video to learn how to effortlessly list and manage your unit.",
    ctaLabel: 'Go to New Feature!',
    ctaPath: '/timeshare/new',
    iframeTitle: 'New Listing Feature Walkthrough',
    ctaButtonClassName:
      'h-11 w-full max-w-sm rounded-full bg-primary/90 text-base font-semibold text-white hover:bg-primary sm:w-auto sm:min-w-[240px] sm:px-10'
  }
];
